import getRecipientDisplayName from '../selectors/getRecipientDisplayName';
import { TooltipHost, TooltipOverflowMode } from '@fluentui/react/lib/Tooltip';
import ChatPersona from './ChatPersona';
import ChatHeaderGroupInfoButton from './ChatHeaderGroupInfoButton';
import * as React from 'react';
import type ChatViewState from '../store/schema/ChatViewState';

export interface ChatHeaderPersonaProps {
    linkedChatViewState: ChatViewState;
}

import styles from './ChatHeaderPersona.scss';
import classNames from 'classnames';

export default function ChatHeaderPersona(props: ChatHeaderPersonaProps) {
    const { participants, subject } = props.linkedChatViewState;
    const isGroup = participants.length > 1;
    const firstRecipientDisplayName = getRecipientDisplayName(participants[0]);

    return (
        <>
            <ChatPersona
                linkedChatViewState={props.linkedChatViewState}
                primaryTextClassName={classNames(
                    styles.primaryTextClassName,
                    isGroup || subject ? styles.isSecondaryVisable : undefined
                )}
            />
            {isGroup ? (
                <ChatHeaderGroupInfoButton participants={participants} />
            ) : subject ? (
                <div className={classNames(styles.personaText, styles.secondaryMaxWidth)}>
                    <TooltipHost
                        content={firstRecipientDisplayName}
                        overflowMode={TooltipOverflowMode.Parent}>
                        {firstRecipientDisplayName}
                    </TooltipHost>
                </div>
            ) : null}
        </>
    );
}
